import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api'
import { RiServerLine } from '@remixicon/react'

// Pages without a routeRef never get a sidebar item (see AppNav in @backstage/plugin-app).
export const fleetRouteRef = createRouteRef()

const fleetPage = PageBlueprint.make({
  params: {
    path: '/fleet',
    routeRef: fleetRouteRef,
    title: 'Fleet',
    icon: <RiServerLine size="1em" />,
    loader: async () => {
      const { FleetPage } = await import('./FleetPage')
      return <FleetPage />
    },
  },
})

export const fleetPlugin = createFrontendPlugin({
  pluginId: 'dg-fleet',
  routes: { root: fleetRouteRef },
  extensions: [fleetPage],
})
